import React from 'react';



const HeaderForm = ({ title, yacht_id }) => {
    return (
        <div className='w-ful flex text-2xl font-semibold justify-between items-center gap-2 mb-5 border-b-2 border-p-green'>
            <h1 className='mb-2'>{title}</h1>
        </div>
    );
};

export default HeaderForm;